export default "__VITE_ASSET__DSbknvn5__"